import React, {useState} from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyEmpresas } from '../../components/Empresas/ContentBodyEmpresas'
import './Empresas.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const Empresas = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();


    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='Empresas'  >
                <div className='headerEmpresas'>
                    <HeaderHome
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className="bodyEmpresas">
                    <ContentBodyEmpresas 
                        MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
